
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"logo","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 440 434.69","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M394.81 295.21c0 19.86-14.06 44.24-31.28 54.17l-134.86 77.87c-17.2 9.93-45.34 9.93-62.54 0L31.26 349.38C14.06 339.45 0 315.08 0 295.21V139.47c0-19.86 14.06-44.23 31.26-54.15L166.12 7.45c17.2-9.93 45.34-9.93 62.54 0l134.86 77.87c17.2 9.93 31.28 34.3 31.28 54.15v155.74h.01z","fill":"#f15a2b"}}),_c('path',{attrs:{"d":"M159.12 181.28h178.71v-50.27H159.54c-25.5 0-46.64 8.73-62.82 25.95-38.91 41.42-39.96 145.78-39.96 145.78h279.67v-94.43h-50.25v44.16H110.39c1.12-16.44 8.65-45.87 22.96-61.1 6.48-6.87 14.66-10.09 25.77-10.09z","fill":"#fff"}})])
          )
        }
      }
    